<template>
	<div id="app">

		<navbar :to="'/cinema'" />

		<div class="containner mt-20 text-md">
			<div class="px-20 py-10 rounded box-shadow">

				<div class="flex item-start py-10 border-bottom">
					<div class="gray px-10 py-5 mx-5 filter-left text-right">影院品牌：</div>
					<div class="flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5"
							@click="brand_clicked(null)"
							:class="{'active':routeQuery.brandId==null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="brand of $store.getters.cinemaqueryvo.brands"
							:key="'brand-'+brand.brandId"
							@click="brand_clicked(brand.brandId)"
							:class="{'active':routeQuery.brandId == brand.brandId}">{{brand.brandName}}</div>
					</div>
				</div>

				<!-- <div class="flex item-start py-10 border-bottom">
					<div class="gray px-10 py-5 mx-5 filter-left text-right">行政地区：</div>
					<div class="flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5"
							@click="location_clicked(undefined)"
							:class="{'active':selected_location_id==undefined}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="location of location_list"
							:key="'location-'+location.location_id"
							@click="location_clicked(location.location_id)"
							:class="{'active':selected_location_id == location.location_id}">{{location.location_name}}</div>
					</div>
				</div>
 -->
				<div class="flex item-start py-10 border-bottom">
					<div class="gray px-10 py-5 mx-5 filter-left text-right">放映厅：</div>
					<div class="flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5"
							@click="hall_category_clicked(null)"
							:class="{'active':routeQuery.specialHallId==null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="hall of $store.getters.cinemaqueryvo.specialHalls"
							:key="'hall_category-'+hall.specialId"
							@click="hall_category_clicked(hall.specialId)"
							:class="{'active':routeQuery.specialHallId == hall.specialId}">{{hall.specialName}}</div>
					</div>
				</div>

				<div class="flex item-start py-10">
					<div class="gray px-10 py-5 mx-5 filter-left text-right">票务服务：</div>
					<div class="flex wrap filter-right">
						<div class="px-10 py-5 dark hand rounded option mx-5"
							@click="service_clicked(undefined)"
							:class="{'active':routeQuery.service==null}">全部</div>
						<div class="px-10 py-5 dark hand rounded option mx-5 hover-red"
							v-for="service of services"
							:key="'service-'+service.serId"
							@click="service_clicked(service.serId)"
							:class="{'active':routeQuery.service == service.serId}">{{service.serName}}</div>
					</div>
				</div>
			</div>
		</div>

		<div class="containner mt-40">
			<div class="text-left text-xl gray weight">影院列表</div>
			<cinema v-for="cinema of $store.getters.cinemaqueryvo.cinemas"
				:key="'cinema-'+cinema.cmaId"
				:cinema="cinema"
				@click="cinema_click(cinema.cmaId)" />
		</div>
		
		
		<div v-if="$store.getters.cinemaqueryvo.bo">
			<page :totalpage="$store.getters.cinemaqueryvo.bo.totalPage" @parentClick="pageEvent"/>
		</div>
		
	
		<foot />

	</div>
</template>

<script>
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	import cinema from '@/components/cinema.vue'
	import page from '@/components/page.vue'
	
	export default {
		data () {
			return {
				routeQuery: {
					currentIndex: 1,
					totalRecord: 0,
					totalPage: 0,
					orderCol: null,
					orderDir: null,
					brandId: null,
					specialHallId: null,
					service: null
				},
				services: [
					{serName: '改签', serId: 2},
					{serName: '退', serId: 1}
				]
			}
		},
		components:{
			navbar,
			foot,
			cinema,
			page
		},
		methods: {
			loads () {
				this.$store.dispatch('actCinemaLoad',{payload: this.routeQuery})
				.then(res => {
					
				})
			},
			handFilter (routequery) {
				this.$router.push({
					path: '/cinemalist',
					query: routequery
				})
			},
			brand_clicked (brand) {
				this.routeQuery.brandId = brand
				this.handFilter(this.routeQuery)
			},
			hall_category_clicked (hall) {
				this.routeQuery.specialHallId = hall
				this.handFilter(this.routeQuery)
			},
			service_clicked (service) {
				this.routeQuery.service = service
				this.handFilter(this.routeQuery)
			},
			cinema_click (cmaId) {
				this.$router.push({
					path: `/cinema/${cmaId}`
				})
			},
			pageEvent (event) {
				this.routeQuery.currentIndex = event
				this.handFilter(this.routeQuery)
			}
		},
		mounted () {
			this.loads()
		},
		watch: {
		   "$route": "loads"
		}
	}
</script>

<style>
	.filter-left{width: 80px;}
	.filter-right{width: 1080px;}
	.option.active{background-color: #e1251b; color: #fff;}
</style>
